import { apiRest } from "../api/constants";

// localStorage events are scoped by browser origin; the API key also separates
// platform configurations on an origin. The marker contains no credentials.
export const logoutSignalKey = `delibran:shop:logout:${apiRest}`;
export const logoutRevision = () => localStorage.getItem(logoutSignalKey);
export const publishLogout = () => localStorage.setItem(logoutSignalKey, `${Date.now()}:${Math.random()}`);
export const isShopLogoutEvent = (event) => event.storageArea === localStorage && event.key === logoutSignalKey && event.newValue !== null && event.newValue !== event.oldValue;
